import { makeStyles } from "@material-ui/core/styles";
import * as colors from "../../../../theme/colors";

const useStyles = makeStyles(() => ({

  content: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    fontWeight: 400,
    fontSize: 16,
    lineHeight: "24px",
    paddingTop: 4,
    color: colors.darkBlue900,
  },

  textSelected: {
    color: colors.ideGreen500,
    fontWeight: 700,
    marginTop: 8,
  },

  logo: {
    marginLeft: 25,
  },

  viewBtnIDE: {
    padding: "12px 20px",
    borderRadius: 12,
    fontSize: 14,
    textTransform: "none",
    color: colors.darkBlue900,
  },

  controls: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 6,
  },

  codeJamLogo: {
    width: 355,
    height: 232,
  }
}));

export { useStyles };
